// /checkout/:slug — página pública de checkout (sem auth), white-label.
// Cliente vem do botão "Upgrade" de algum SaaS do portfólio (OwlTask, Reservei, etc).
// Query string: ?email=X&name=Y&saas=Z&cycle=anual&redirect=URL_OPCIONAL
//
// Dois layouts (2026-10-20):
// - Reservei → checkout próprio (components/checkout-reservei/ReserveiCheckout.tsx).
// - Demais SaaS → checkout padrão (components/checkout-public/CheckoutFlow.tsx).
// A escolha usa a mesma regra de origem que os dois usam por dentro
// (resolveCheckoutOrigin) — se divergisse, o Reservei poderia cair no layout errado.

import { useSearchParams } from 'react-router-dom';

import { CheckoutFlow } from '../../components/checkout-public/CheckoutFlow';
import { resolveCheckoutOrigin } from '../../components/checkout-public/use-checkout-entry';
import { ReserveiCheckout } from '../../components/checkout-reservei/ReserveiCheckout';

export function PublicCheckoutPage(): JSX.Element {
  const [searchParams] = useSearchParams();
  return resolveCheckoutOrigin(searchParams) === 'reservei' ? <ReserveiCheckout /> : <CheckoutFlow />;
}
